<template>
  <div class="row">
    <div class="header-spacer"></div>
    <div class="subnav-spacer"></div>
    <div class="d-flex col-12 sub-nav justify-content-between">
      <h3 class="fw-b fs-32 ff-os-b mb-0">{{ $t(`${$options.name}.title`) }}</h3>
      <div>
        <button v-if="selectedTemplates.length === 1" class="btn btn-primary mr-8" @click="duplicate()">{{ $t('general.duplicate') }}</button>
        <router-link class="btn btn-primary" :to="{ name: 'admin-template-create' }">{{ $t('general.add') }}</router-link>
      </div>
    </div>

    <vue-good-table class="col-12" :columns="columns" @on-cell-click="goTo" :search-options="{ enabled: true, placeholder: $t(`${$options.name}.search`) }" :rows="templates" @on-selected-rows-change="selectionChanged" :select-options="{ enabled: true, disableSelectInfo: true }" styleClass="vgt-table">
      <template slot="table-row" slot-scope="slotProps">
        <span v-if="slotProps.column.field === 'creator' && slotProps.row.creator" class="d-flex flex-row align-contents-center">
          <el-avatar class="my-auto" :user="slotProps.row.creator"></el-avatar>
          <p class="my-auto ml-8">{{ slotProps.row.creator.first_name }} {{ slotProps.row.creator.last_name }}</p>
        </span>
        <span v-else>
          {{ slotProps.formattedRow[slotProps.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';
import HasForm from '@/components/forms/has-form';
import { ElAvatar } from '@/components/elements/_index';
import HasTableExport from '../has-table-export';

export default {
  name: 'views.admin.templates',

  components: {
    VueGoodTable,
    ElAvatar,
  },

  mixins: [HasForm, HasTableExport],

  data() {
    return {
        columns: [
            { width: '50px', label: 'id', field: 'id', sortable: false },
            { width: '150px', label: this.$t(`${this.$options.name}.template`), field: 'title', sortable: true },
            { width: '150px', label: this.$t(`${this.$options.name}.last_updated`), field: 'updated_at', sortable: true, type: 'date', dateInputFormat: 'yyyy-MM-dd', dateOutputFormat: 'PP' },
            { width: '180px', label: this.$t(`${this.$options.name}.created_by`), field: 'owner', sortable: true },
            { width: '180px', label: this.$t(`${this.$options.name}.in_use`), field: 'in_use', sortable: true },
            { width: '180px', label: this.$t(`${this.$options.name}.created_at`), field: 'created_at', sortable: true, type: 'date', dateInputFormat: 'yyyy-MM-dd', dateOutputFormat: 'PP' },
        ],
        selectedTemplates: [],
    }
  },

  methods: {
    goTo(params) {
      if (params.column === 0) {
        return;
      }
      this.$router.push({ name: 'admin-template-update', params: { templateId: params.row.id } });
    },
    selectionChanged(changes) {
      this.selectedTemplates = changes.selectedRows.map((u) => {
        return { id: u.id };
      });
    },
    duplicate() {
      const id = this.selectedTemplates[0].id;
      this.$store.dispatch('template/duplicate', id).then((template) => {
        this.$toasted.show(this.toastHtml('Template duplicated!'), {
          theme: 'outline',
          position: 'bottom-right',
          duration: 5000,
        });
        this.$router.push({ name: 'admin-template-update', params: { templateId: template.id } });
      });
    },
  },

  computed: {
    templates() {
      return this.$store.getters['template/all'];
    },
  },
};
</script>
